import { InvitationLocationItem } from '@/features/invitation/application/domain/entities/InvitationLocationItem';
import { InvitationLocationItemDto } from '../dto/res/InvitationLocationItemDto';

export function mapInvitationLocationDtoToEntity(
  dto: InvitationLocationItemDto,
): InvitationLocationItem {
  return {
    value: dto.locationId,
    label: dto.locationName,
  };
}
